import React from "react";

const NavigationModal = ({
  open,
  steps,
  currentStep,
  onClose,
  onPrev,
  onNext,
}) => {
  if (!open || !steps || steps.length === 0) return null;
  const step = steps[currentStep] || {};
  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative bg-[#181c23] rounded-2xl p-8 min-w-[320px] max-w-[400px] shadow-2xl border border-[#23272f] text-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="font-bold text-lg mb-3 tracking-wide text-amber-300 flex items-center gap-2">
          <span className="inline-block w-2 h-2 bg-amber-400 rounded-full animate-pulse"></span>
          步驟 {currentStep + 1} / {steps.length}
        </div>
        <div className="mb-3 text-base leading-relaxed text-gray-200">
          <div dangerouslySetInnerHTML={{ __html: step.instructions || "" }} />
        </div>
        <div className="text-sm mb-2 flex items-center gap-3 text-amber-200">
          <span className="inline-flex items-center gap-1">
            <svg
              className="w-4 h-4 text-amber-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.657 16.657L13.414 12.414a2 2 0 00-2.828 0l-4.243 4.243M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            距離：{step.distance}
          </span>
          <span className="inline-flex items-center gap-1">
            <svg
              className="w-4 h-4 text-amber-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3"
              />
            </svg>
            預計：{step.duration}
          </span>
        </div>
        <div className="flex justify-between mt-6">
          <button
            onClick={onPrev}
            disabled={currentStep === 0}
            className="px-5 py-2 rounded-lg bg-[#23272f] text-gray-300 hover:bg-amber-700/80 hover:text-white transition disabled:opacity-40 disabled:cursor-not-allowed shadow"
          >
            上一步
          </button>
          <button
            onClick={onNext}
            disabled={currentStep === steps.length - 1}
            className="px-5 py-2 rounded-lg bg-amber-700 text-white hover:bg-amber-600 transition disabled:opacity-40 disabled:cursor-not-allowed shadow"
          >
            下一步
          </button>
        </div>
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-2xl text-gray-400 hover:text-amber-400 transition bg-transparent border-none cursor-pointer"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default NavigationModal;
